import { render, staticRenderFns } from "./GalleryViewPreview.vue?vue&type=template&id=52717e0a&scoped=true"
import script from "./GalleryViewPreview.vue?vue&type=script&lang=ts"
export * from "./GalleryViewPreview.vue?vue&type=script&lang=ts"
import style0 from "./GalleryViewPreview.vue?vue&type=style&index=0&id=52717e0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52717e0a",
  null
  
)

export default component.exports